import React from "react"
import ProgressBar from "../../atoms/chart/chart-progress-bar"

const Format = ({ dataVal, dataType = 'string' }) => {

	let output;

	const curLoc = process.env.GATSBY_SITE_LANG.replace('_',"-") || 'en_US';

	console.log(curLoc);

	switch (dataType) {
		case 'int':
			output = !isNaN(dataVal) ? Number(Math.round(dataVal)).toLocaleString(curLoc) : dataVal
			break;
		case 'float':
			output = !isNaN(dataVal) ? Number(Math.round(dataVal+'e2')+'e-2').toLocaleString(curLoc) : dataVal // round to 2 dec. points
			break;
		case 'percent':
			output = !isNaN(dataVal) ? Number(Math.round((dataVal*100)+'e1')+'e-1').toLocaleString(curLoc)+'%' : dataVal // round to 2 dec. points
			break;
		case 'percent-int':
			output = !isNaN(dataVal) ? Number(Math.round((dataVal)+'e1')+'e-1').toLocaleString(curLoc)+'%' : dataVal// round to 2 dec. points
			break;
		case 'progress':
			output = !isNaN(dataVal) ? <ProgressBar val={dataVal * 100} />  : dataVal
			break;
		case 'eur':
			output = '€'+dataVal.toLocaleString(curLoc);
			break;
		case 'string':
		case 'spacer':
			output = dataVal.toString();
		default:
			output = dataVal;
			break;
	}
	
	return output;
}

export default Format